import Image from 'next/image';

import { useGetSrSupplierQuery } from '../../api';
import { Button } from '../../ui';

export const Overview = ({
  requestId,
  matchId,
}: {
  requestId: string;
  matchId: string;
}) => {
  const { data: supplier } = useGetSrSupplierQuery({
    id: requestId,
    matchId,
  });

  return (
    <div className="p-4 space-y-6">
      <div className="flex flex-col gap-4">
        <span className="text-xl font-bold">Company Description</span>
        <span>{supplier?.supplierData.description}</span>
      </div>
      <div className="flex items-start gap-4 p-6 bg-secondary-25 rounded-[2rem]">
        <div className="bg-secondary-50 p-4 rounded-full">
          <Image src="/icons/growth.svg" width={24} height={24} alt="Avatar" />
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-xl font-bold">Annual Growth Rate</span>
          <span>25%</span>
        </div>
      </div>
      <div className="flex items-start gap-4 p-6 bg-primary-25 rounded-[2rem]">
        <div className="bg-primary-50 p-4 rounded-full">
          <Image src="/icons/product.svg" width={24} height={24} alt="Avatar" />
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-xl font-bold">Product & Service Offerings</span>
          <div className="flex gap-2 flex-wrap">
            <div className="px-4 py-1 rounded-[2rem] bg-primary-500 text-white">
              Personal Protective Equipment
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-50 text-primary-700">
              Personal Protective Equipment
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-500 text-white">
              Medical Consumables
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-50 text-primary-700">
              Customized Supply Chain Management
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-50 text-primary-700">
              Diagnostic Tools
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-50 text-primary-700">
              Surgical Instruments
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-500 text-white">
              Pharmaceutical Products
            </div>
          </div>
        </div>
      </div>
      <Button
        text="View Capability Statement"
        prefixIcon="/icons/file-blue.svg"
        variant="secondary"
      />
      <div className="flex items-start gap-4 p-6 bg-primary-25 rounded-[2rem]">
        <div className="bg-primary-50 p-4 rounded-full">
          <Image src="/icons/link.svg" width={24} height={24} alt="Avatar" />
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-xl font-bold">Websites</span>
          <div className="flex gap-2 flex-wrap">
            {supplier?.website && (
              <a
                className="px-4 py-1 rounded-[2rem] bg-primary-50 text-primary-700"
                href={supplier?.website}
                target="_blank"
              >
                {supplier?.website}
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="flex items-start gap-4 p-6 bg-secondary-25 rounded-[2rem]">
        <div className="bg-secondary-50 p-4 rounded-full">
          <Image
            src="/icons/building.svg"
            width={24}
            height={24}
            alt="Avatar"
          />
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-xl font-bold text-text-primary">Industry</span>
          <span className="text-text-secondary">
            {supplier?.supplierData?.industry}
          </span>
          <div className="flex gap-80">
            <div className="flex flex-col gap-2">
              <div className="flex flex-col">
                <span className="text-text-primary">Headquarter City</span>
                <span className="text-text-secondary">{supplier?.city}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-text-primary">Established</span>
                <span className="text-text-secondary">
                  {supplier?.supplierData?.establishmentDate}
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex flex-col">
                <span className="text-text-primary">Headquarter State</span>
                <span className="text-text-secondary">{supplier?.state}</span>
              </div>
              <div className="flex flex-col">
                <span className="text-text-primary">Years in Business</span>
                <span className="text-text-secondary">28</span>
              </div>
            </div>
          </div>
          <span className="text-xl font-bold">Geographies Served</span>
          <div className="flex gap-2 flex-wrap">
            <div className="px-4 py-1 rounded-[2rem] bg-secondary-500 text-white">
              Northeast
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-secondary-500 text-white">
              Southeast
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-secondary-50 text-secondary-700">
              Midwest
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-secondary-50 text-secondary-700">
              Southwest
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-secondary-50 text-secondary-700">
              West
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-start gap-4 p-6 bg-primary-25 rounded-[2rem]">
        <div className="bg-primary-50 p-4 rounded-full">
          <Image src="/icons/product.svg" width={24} height={24} alt="Avatar" />
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-xl font-bold">Business Activities</span>
          <span className="text-text-secondary">
            {supplier?.supplierData?.primaryBusinessActivity}
          </span>
          <span className="text-text-primary font-[500]">
            Product & Service Offerings
          </span>
          <div className="flex gap-2 flex-wrap">
            <div className="px-4 py-1 rounded-[2rem] bg-primary-500 text-white">
              Personal Protective Equipment
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-50 text-primary-700">
              Personal Protective Equipment
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-500 text-white">
              Medical Consumables
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-50 text-primary-700">
              Customized Supply Chain Management
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-50 text-primary-700">
              Diagnostic Tools
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-50 text-primary-700">
              Surgical Instruments
            </div>
            <div className="px-4 py-1 rounded-[2rem] bg-primary-500 text-white">
              Pharmaceutical Products
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-start gap-4 p-6 bg-[#FFF3F0] rounded-[2rem]">
        <div className="bg-[#FFE1DA] p-4 rounded-full">
          <Image src="/icons/tag.svg" width={24} height={24} alt="Avatar" />
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-xl font-bold">NAICS Codes</span>
          <div className="flex gap-2 flex-wrap">
            {supplier?.supplierData?.naics.map(
              (naic: { code: string; label: string }) => (
                <div
                  key={naic.code}
                  className="px-4 py-1 rounded-[2rem] bg-[#FF866A] text-white"
                >
                  {naic.code}: {naic.label}
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
